import React, { useContext } from 'react'
import Navigation from '@App/navigation'
import Button from '@Components/Buttons/Button'
import { StoresContext } from '@App/contexts'
import HelpMenu from '@Components/Navigations/HelpMenu'
import NavBarWrapper from '@Components/Navigations/NavBar/NavBarWrapper'
import { observer } from 'mobx-react'
import PublicSearchNavLink from '@Components/Navigations/PublicSearchNavLink'

const NotLoggedInNavBar = () => {
    const { uiStore } = useContext(StoresContext)

    const onLoginPage = uiStore.onLoginPage

    return (
        <NavBarWrapper
            rightBlock={
                <>
                    <PublicSearchNavLink />
                    <HelpMenu />
                    {onLoginPage ? (
                        <Button typeLink linkTo={Navigation.signUp.root()} mainColor type="primary">
                            Sign Up
                        </Button>
                    ) : (
                        <Button typeLink linkTo={Navigation.login.root()} mainColor type="primary">
                            Log In
                        </Button>
                    )}
                </>
            }
        />
    )
}

export default observer(NotLoggedInNavBar)
